/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerLocationCounties.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Location Counties
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, May 13, 2019 - 10:08:57 PM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      05/13/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    LOCATIONCOUNTY_LIST_CONTAINER_LOADED,
    LOCATIONCOUNTY_LIST_CONTAINER_UNLOADED,
    LOCATIONCOUNTY_LIST_TABLE_LOADED,
    LOCATIONCOUNTY_LIST_TABLE_UNLOADED,

    LOCATIONCOUNTY_LIST_CHANGE_GROUP,

    LOCATIONCOUNTY_SELECT_ROW,
    LOCATIONCOUNTY_ADD,
    LOCATIONCOUNTY_EDIT,
    LOCATIONCOUNTY_DELETE,
    LOCATIONCOUNTY_OPEN_WARNING,
    LOCATIONCOUNTY_CLOSE_WARNING,
    LOCATIONCOUNTY_DELETE_DISABLE,

    LOCATIONCOUNTY_EDIT_CONTAINER_LOADED,
    LOCATIONCOUNTY_EDIT_CONTAINER_UNLOADED,
    LOCATIONCOUNTY_EDIT_FORM_LOADED,
    LOCATIONCOUNTY_EDIT_FORM_UNLOADED,
    LOCATIONCOUNTY_EDIT_DATA_LOAD,
    LOCATIONCOUNTY_EDIT_CONTAINER_SUBMIT,
    LOCATIONCOUNTY_EDIT_CONTAINER_CANCEL
} from '../constants/actionTypeLocationCounties';

const defaultState = {
    refreshList: false,
    danger: false,
    locationcountyid: 0,
    country: '',
    state: '',
    name: '',
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case LOCATIONCOUNTY_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                locationcounties: action.payload[0] ? action.payload[0].records : null,
                countries: action.payload[1] ? action.payload[1].records : null,
                states: action.payload[2] ? action.payload[2].records : null
            }
        case LOCATIONCOUNTY_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case LOCATIONCOUNTY_LIST_CHANGE_GROUP:
            return {
                ...state,
                [action.key]: action.payload ? action.payload : []
            }
        case LOCATIONCOUNTY_SELECT_ROW:
            return {
                ...state,
                locationcountyid: action.id
            }
        case LOCATIONCOUNTY_ADD:
            return {
                ...state
            }
        case LOCATIONCOUNTY_EDIT:
            return {
                ...state,
                locationcountyid: action.id
            }
        case LOCATIONCOUNTY_DELETE:
            return {
                ...state,
                locationcountyid: null
            }
        case LOCATIONCOUNTY_DELETE_DISABLE:
            return {
                ...state,
                disableDelete: action.disabled
            }
        case LOCATIONCOUNTY_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case LOCATIONCOUNTY_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case LOCATIONCOUNTY_EDIT_CONTAINER_LOADED:
        case LOCATIONCOUNTY_EDIT_DATA_LOAD:
            return {
                ...state,
                locationcountyid: action.payload[0] ? action.payload[0].locationcountyid : 0,
                countryid: action.payload[0] ? action.payload[0].countryid : 0,
                country: action.payload[1] ? action.payload[1].name : action.payload[0] ? action.payload[0].country : '',
                stateid: action.payload[0] ? action.payload[0].stateid : 0,
                state: action.payload[2] ? action.payload[2].name : action.payload[0] ? action.payload[0].state : '',
                name: action.payload[0] ? action.payload[0].name : '',
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }
        case LOCATIONCOUNTY_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case LOCATIONCOUNTY_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case LOCATIONCOUNTY_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case LOCATIONCOUNTY_LIST_CONTAINER_UNLOADED:
        case LOCATIONCOUNTY_LIST_TABLE_UNLOADED:
        case LOCATIONCOUNTY_EDIT_CONTAINER_UNLOADED:
        case LOCATIONCOUNTY_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/reducerLocationCounties.js